import config from '../services/config';
import CommonFunctions from '../services/commonFunctions';
import browserDetectService from '../services/browserDetectService';
import localStorageService from '../services/localStorageService';
import raceReplayService from '../services/raceReplayService';
import userPreference from '../services/userPreference';
import ugc from '../services/ugc';


export default angular.module('CommonUtils', [])
    .provider('config', config)
    .factory('CommonFunctions', CommonFunctions)
    .service('browserDetectService', browserDetectService)
    .service('localStorageService', localStorageService)
    .service('raceReplayService', raceReplayService)
    .service('userPreference', userPreference)
    .service('ugc', ugc);



// WEBPACK FOOTER //
// ./src/js/modules/CommonUtils.js